/* MBroidery personalisatie configurator - los asset, initialiseert elke .mbperso op de pagina */
(function(){
  function init(root){
    if(root.dataset.mbpInit) return; root.dataset.mbpInit = '1';
    var GIFT = parseFloat(root.dataset.gift) || 0;
    var BASE = parseFloat(root.dataset.base) || 0;
    var variants = [];
    var threadsRaw = '';
    var swatchMap = {};
    try { variants = JSON.parse(root.querySelector('[data-mbp-variants]').textContent || '[]'); } catch(e){ variants = []; }
    try { threadsRaw = JSON.parse(root.querySelector('[data-mbp-threads]').textContent || '""'); } catch(e){ threadsRaw = ''; }
    try { var _sw = root.querySelector('[data-mbp-swatches]'); if(_sw){ swatchMap = JSON.parse(_sw.textContent || '{}') || {}; } } catch(e){ swatchMap = {}; }
    function swatchColor(naam){ var h = swatchMap[naam]; return (h && String(h).trim()) ? h : kleurHex(naam); }

    var stockmap = {};
    try { var _st = root.querySelector('[data-mbp-stock]'); if(_st){ stockmap = JSON.parse(_st.textContent || '{}') || {}; } } catch(e){ stockmap = {}; }
    var STOCKDREMPEL = parseInt(root.dataset.stockdrempel, 10) || 5;
    function renderStock(vid){
      var el = root.querySelector('#mbp-stock'); if(!el) return;
      var s = vid ? stockmap[vid] : null;
      if(s && s.m && s.p === 'deny' && s.q > 0 && s.q <= STOCKDREMPEL){ el.textContent = 'Nog ' + s.q + ' beschikbaar'; el.style.display=''; }
      else { el.textContent=''; el.style.display='none'; }
    }

    var threads = (threadsRaw || '').split('\n').map(function(l){ return l.trim(); }).filter(Boolean).map(function(l){
      var parts = l.split('|'); var name = (parts[0]||'').trim(); var val = (parts[1]||'').trim();
      var isImg = /^https?:\/\//.test(val);
      return { name: name, hex: isImg ? '' : (val||'#eee'), img: isImg ? val : '' };
    });

    var KLEURMAP = {
      'zwart':'#1c1c1c','donkergrijs':'#5b5b5b','sportgrijs':'#b9b9b9','grijs':'#9a9a9a','lichtgrijs':'#cfcfcf',
      'donkerblauw':'#22314f','royaal blauw':'#2f5fb0','royaalblauw':'#2f5fb0','lichtblauw':'#8db8e0','blauw':'#3a6bb0','nachtblauw':'#1f2a44','denim':'#4a6a8a',
      'donkergroen':'#22492d','groen':'#3f7d48','lichtgroen':'#8bbf6f','kaki':'#7a7a52',
      'bordeaux':'#5c1e29','rood':'#a4262c','terracotta':'#b5643f','toffee':'#8a5a34','bruin':'#6b4a34',
      'roze':'#e78bb0','lichtroze':'#f4c9dd','oud roze':'#d29aad','lila':'#b79ec9','paars':'#5b2a6b',
      'geel':'#e6c33a','oranje':'#dd6a2c','natuur':'#e9e2d3','wit':'#f4f4f2','beige':'#d9c9ac'
    };
    function kleurHex(naam){ var k=(naam||'').toLowerCase().trim(); return KLEURMAP[k] || '#d8c4cf'; }

    var kleuren = [], maten = [];
    variants.forEach(function(v){
      if(v.option1 && kleuren.indexOf(v.option1)<0) kleuren.push(v.option1);
      if(v.option2 && maten.indexOf(v.option2)<0) maten.push(v.option2);
    });

    var state = { kleur: kleuren[0]||null, maat: null, qty: 1, gift: false };
    function money(n){ return '€ ' + n.toFixed(2).replace('.', ','); }

    var kleurWrap = root.querySelector('#mbp-kleur');
    kleuren.forEach(function(kl, i){
      var v = variants.find(function(x){ return x.option1===kl; });
      var img = (v && v.featured_image && v.featured_image.src) ? v.featured_image.src : '';
      var d = document.createElement('div');
      d.className = 'sw' + (i===0?' sel':''); d.dataset.kleur = kl;
      d.style.background = swatchColor(kl);
      d.innerHTML = '<span>'+kl+'</span>';
      d.onclick = function(){ selectKleur(kl, img); };
      kleurWrap.appendChild(d);
    });

    var maatWrap = root.querySelector('#mbp-maat');
    function renderMaten(){
      maatWrap.innerHTML='';
      maten.forEach(function(m){
        var v = variants.find(function(x){ return x.option1===state.kleur && x.option2===m; });
        var avail = v && v.available;
        var c = document.createElement('div');
        c.className='card'+(avail?'':' soldout')+(state.maat===m?' sel':'');
        c.dataset.maat=m; c.innerHTML='<div class="ct">'+m+'</div>';
        if(avail){ c.onclick=function(){ state.maat=m; renderMaten(); recalc(); }; }
        maatWrap.appendChild(c);
      });
    }

    function selectKleur(kl, img){
      state.kleur = kl;
      root.querySelectorAll('#mbp-kleur .sw').forEach(function(s){ s.classList.toggle('sel', s.dataset.kleur===kl); });
      if(img){ var mi=root.querySelector('#mbp-mainimg'); if(mi) mi.src = img; }
      var stillOk = variants.some(function(x){ return x.option1===kl && x.option2===state.maat && x.available; });
      if(!stillOk) state.maat=null;
      renderMaten(); recalc();
    }

    root.querySelectorAll('.thumbs img').forEach(function(t){
      t.onclick=function(){ root.querySelector('#mbp-mainimg').src=t.dataset.full; root.querySelectorAll('.thumbs img').forEach(function(x){x.classList.remove('sel');}); t.classList.add('sel'); };
    });

    root.querySelectorAll('.mbp-threads').forEach(function(tcs){
      threads.forEach(function(t, idx){
        var d=document.createElement('div'); d.className='tc'+(idx===0?' sel':''); d.dataset.name=t.name;
        if(t.img){ d.style.backgroundImage='url('+t.img+')'; } else { d.style.background=t.hex; }
        d.title=t.name;
        tcs.appendChild(d);
      });
      var nameEl = tcs.parentElement.querySelector('.mbp-threadname');
      if(nameEl && threads[0]) nameEl.textContent = 'Kleur draad - ' + threads[0].name;
      tcs.querySelectorAll('.tc').forEach(function(tc){
        tc.onclick=function(){
          tcs.querySelectorAll('.tc').forEach(function(x){x.classList.remove('sel');}); tc.classList.add('sel');
          if(nameEl) nameEl.textContent='Kleur draad - '+tc.dataset.name;
          var pv = tcs.parentElement.querySelector('.mbp-pv'); if(pv && tc.style.backgroundColor) pv.style.color=tc.style.backgroundColor;
        };
      });
    });

    function toRoman(n){ n=parseInt(n,10); if(!n||n<1) return ''; var m=[[1000,'M'],[900,'CM'],[500,'D'],[400,'CD'],[100,'C'],[90,'XC'],[50,'L'],[40,'XL'],[10,'X'],[9,'IX'],[5,'V'],[4,'IV'],[1,'I']],r=''; m.forEach(function(pr){ while(n>=pr[0]){ r+=pr[1]; n-=pr[0]; } }); return r; }
    function dateToRoman(s){ var p=(s||'').split(/[^0-9]+/).filter(Boolean); return p.length? p.map(toRoman).join('·') : ' '; }

    root.querySelectorAll('.optrow').forEach(function(row){
      var step = row.closest('[data-step]');
      row.querySelectorAll('.opt').forEach(function(o){
        o.onclick=function(){
          row.querySelectorAll('.opt').forEach(function(x){x.classList.remove('sel');}); o.classList.add('sel');
          ['.txtsub','.datumsub','.omrandsub','.upsub'].forEach(function(cls){ var e=step.querySelector(cls); if(e) e.classList.add('hide'); });
          var map={tekst:'.txtsub',datum:'.datumsub',omrand:'.omrandsub',opgevuld:'.upsub'};
          var show=map[o.dataset.key]; if(show){ var e=step.querySelector(show); if(e) e.classList.remove('hide'); }
          var pick = step.querySelector('.pick'); if(pick) pick.textContent=o.dataset.name;
          recalc();
        };
      });
    });

    root.querySelectorAll('.txtsub, .datumsub').forEach(function(sub){
      var pv=sub.querySelector('.mbp-pv'), input=sub.querySelector('.tin'), isDate=sub.classList.contains('datumsub'), heart=sub.querySelector('.mbp-heart');
      function renderpv(){ if(!pv||!input) return; var base= isDate ? dateToRoman(input.value) : (input.value||''); if(heart&&heart.checked) base += ' ♥'; pv.textContent = base||' '; }
      if(input) input.addEventListener('input', renderpv);
      if(heart) heart.addEventListener('change', renderpv);
      var fsel=sub.querySelector('.mbp-font'); if(fsel){ fsel.addEventListener('change', function(){ var o=this.options[this.selectedIndex]; pv.style.fontFamily=o.getAttribute('data-font'); pv.style.fontStyle=o.getAttribute('data-style')||'normal'; pv.style.fontWeight=o.getAttribute('data-weight')||'400'; }); }
    });

    var giftcard=root.querySelector('#mbp-giftcard');
    if(giftcard) giftcard.onclick=function(){ state.gift=!state.gift; this.classList.toggle('sel', state.gift); var gp=root.querySelector('#mbp-giftpick'); if(gp) gp.textContent = state.gift?'Ja':''; recalc(); };

    root.querySelector('#mbp-plus').onclick=function(){ state.qty++; recalc(); };
    root.querySelector('#mbp-min').onclick=function(){ if(state.qty>1){ state.qty--; recalc(); } };

    root.querySelectorAll('.stephead').forEach(function(h){ h.onclick=function(e){
      if(e.target.closest('.giftcard')) return;
      var s=h.parentElement, isOpen=s.classList.contains('open');
      root.querySelectorAll('.step').forEach(function(x){x.classList.remove('open');}); if(!isOpen) s.classList.add('open');
    };});

    function optiesTotaal(){
      var add=0;
      root.querySelectorAll('.optrow .opt.sel').forEach(function(o){ add += parseFloat(o.dataset.add||0); });
      if(state.gift) add += GIFT;
      return add;
    }
    function recalc(){
      var add=optiesTotaal();
      var per = BASE + add;
      root.querySelector('#mbp-perstuk').textContent = money(per);
      root.querySelector('#mbp-headprice').textContent = money(BASE);
      root.querySelector('#mbp-optline').textContent = add>0 ? ('waarvan '+money(add)+' aan opties') : 'basisprijs, nog geen opties';
      root.querySelector('#mbp-qty').textContent = state.qty;
      root.querySelector('#mbp-km').textContent = (state.kleur||'') + (state.maat? ' · '+state.maat : '');
      var addBtn = root.querySelector('#mbp-add');
      addBtn.disabled = !state.maat;
      addBtn.textContent = state.maat ? 'In je winkelmandje' : 'Kies eerst een maat';
      var _hv = huidigeVariant(); renderStock(_hv ? _hv.id : null);
    }

    function verzamelPlek(plek){
      var step = root.querySelector('[data-plek="'+plek+'"]');
      if(!step) return {};
      var sel = step.querySelector('.optrow .opt.sel');
      var key = sel ? sel.dataset.key : 'niks';
      var props={};
      var label = plek.charAt(0).toUpperCase()+plek.slice(1);
      if(key==='niks'){ return props; }
      props[label] = sel.dataset.name;
      var threadName = function(sub){ var t=sub.querySelector('.mbp-threads .tc.sel'); return t? t.dataset.name : ''; };
      if(key==='tekst'){
        var sub=step.querySelector('.txtsub');
        props[label+' tekst'] = sub.querySelector('.tin').value;
        var f=sub.querySelector('.mbp-font'); if(f) props[label+' lettertype']=f.value;
        var tn=threadName(sub); if(tn) props[label+' draadkleur']=tn;
        var h=sub.querySelector('.mbp-heart'); if(h && h.checked) props[label+' hartje']='Ja';
      } else if(key==='datum'){
        var sub2=step.querySelector('.datumsub');
        props[label+' datum'] = sub2.querySelector('.tin').value;
        var tn2=threadName(sub2); if(tn2) props[label+' draadkleur']=tn2;
      } else if(key==='omrand'){
        var sub3=step.querySelector('.omrandsub');
        var tn3=threadName(sub3); if(tn3) props[label+' draadkleur']=tn3;
      }
      return props;
    }

    function huidigeVariant(){ return variants.find(function(x){ return x.option1===state.kleur && x.option2===state.maat; }); }

    root.querySelector('#mbp-add').onclick=function(){
      var v = huidigeVariant();
      if(!v){ return; }
      var props={};
      ['voorkant','rug','mouw'].forEach(function(plek){ Object.assign(props, verzamelPlek(plek)); });
      if(state.gift) props['Cadeauverpakking']='Ja';
      var extra = root.querySelector('.mbp-extra').value; if(extra) props['Extra info']=extra;

      var files=[];
      ['voorkant','rug'].forEach(function(plek){
        var step=root.querySelector('[data-plek=\"'+plek+'\"]'); if(!step) return;
        var sel=step.querySelector('.optrow .opt.sel'); if(!sel) return;
        var key=sel.dataset.key;
        if(key==='omrand' || key==='opgevuld'){
          var sub=step.querySelector(key==='omrand'?'.omrandsub':'.upsub');
          var fi=sub?sub.querySelector('.mbp-file'):null;
          if(fi && fi.files && fi.files[0]){
            files.push({ name: plek.charAt(0).toUpperCase()+plek.slice(1)+' bestand', file: fi.files[0] });
          }
        }
      });

      var addons=[];
      root.querySelectorAll('.optrow .opt.sel').forEach(function(o){
        var vid=o.dataset.vid; var add=parseFloat(o.dataset.add||0);
        if(vid && add>0){ addons.push({ id: parseInt(vid,10), quantity: state.qty }); }
      });
      var giftVid = root.dataset.giftvid;
      if(state.gift && giftVid){ addons.push({ id: parseInt(giftVid,10), quantity: state.qty }); }

      var btn=this; btn.disabled=true; btn.textContent='Toevoegen...';
      function addMain(){
        if(files.length){
          var fd=new FormData();
          fd.append('id', v.id); fd.append('quantity', state.qty);
          Object.keys(props).forEach(function(k){ fd.append('properties['+k+']', props[k]); });
          files.forEach(function(f){ fd.append('properties['+f.name+']', f.file); });
          return fetch('/cart/add.js', { method:'POST', body: fd });
        }
        return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items:[{ id:v.id, quantity:state.qty, properties:props }] }) });
      }
      function addAddons(){
        if(!addons.length) return Promise.resolve();
        return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items: addons }) });
      }
      addMain().then(function(){ return addAddons(); }).then(function(){ window.location.href='/cart'; }).catch(function(){ btn.disabled=false; btn.textContent='In je winkelmandje'; alert('Er ging iets mis, probeer opnieuw.'); });
    };

    renderMaten(); recalc();
  }
  function boot(){ document.querySelectorAll('.mbperso').forEach(init); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
